import React, { useEffect, useState, useCallback, useContext } from "react";
import api, { BASE_URL } from "../../../Utils/api";
import ConfiguracoesCamposModal from "./ConfiguracoesCamposModal";
import GridPadrao from "../../GridPadrao/GridPadrao";
import PageHeader from "../../PageHeader/PageHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../../Utils/GlobalContext";


function ConfiguracoesCampos() {
  const [configuracoes, setConfiguracoes] = useState([]);
  const [selectedConfiguracao, setSelectedConfiguracao] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const token = localStorage.getItem("authToken");
  const permiteEdicao = "S"; // Ajuste para "S" ou "N" 

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Nome", accessor: "nome" },
    { Header: "Descrição", accessor: "descricao" },
  ];

  const fetchConfiguracoes = useCallback(() => {
    
    api
      .get(`${BASE_URL}/api/configuracaoCampos/ListarTiposConfiguracoesCampos/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // Incluindo permiteEdicao em cada configuração
        const lista = Array.isArray(response.data?.data) ? response.data.data : [];
        const configuracoesComPermissao = lista.map(config => ({
          ...config,
          permiteEdicao: permiteEdicao // adiciona a permissão para cada item
        }));
        setConfiguracoes(configuracoesComPermissao);
      })
      .catch((error) => {
        console.error("Erro ao buscar as configurações de campos:", error);
      });
  }, [token, permiteEdicao, entidadeID]);

  useEffect(() => {
    fetchConfiguracoes();
  }, [fetchConfiguracoes]);

  const handleEdit = (configuracao, permiteEdicao) => {
    setSelectedConfiguracao(configuracao);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedConfiguracao(null);
  };

  return (
    <div>
      <PageHeader titulo="Configurações de Campos" path="/ConfiguracoesCampos" />
      <GridPadrao
        columns={columns}
        data={configuracoes}
        onEdit={(configuracao, permiteEdicao) => {handleEdit(configuracao, permiteEdicao)}}
      />

      <ConfiguracoesCamposModal
        show={showModal}
        handleClose={handleClose}
        configuracao={selectedConfiguracao}
        fetchConfiguracoes={fetchConfiguracoes}
      />
    </div>
  );
}

export default ConfiguracoesCampos;
